import React from "react";
import Select from "react-select";
import { customStyles, DropdownIndicator } from "../../../constants";
import Explorer from '../../../data-containers/explorer';

function FleetByTime() {
  const { setDateRange, possibleDateRanges } = Explorer.useContainer();
  function onChange(range){
    setDateRange(range);
  }

  return <div className="dropdown-container">
    <Select
      menuPortalTarget={document.body} 
      options={possibleDateRanges}
      styles={customStyles()}
      onChange={onChange}
      components={{ DropdownIndicator }}
      defaultValue={possibleDateRanges.find(({ isDefault }) => isDefault)}
    />
  </div>;
}

export default FleetByTime;
